<template>
  <div v-if="info" class="block-mentor-container flex">
    <div class="mentor-info-content flex">
      <img class="mentor-avatar" :src="info.photo_url" alt="" />
      <div class="info-content">
        <div class="mentor-name flex align-items-center">
          <span class="name">{{ info.nickname }}</span>
          <img class="rating-icon" src="https://logo.wondercv.com/banners/sI1Sv6qZwlfLxrC.png" alt="" />
          <span class="rating-text">{{ info.rating }}分</span>
        </div>
        <div class="mentor-bio" style="margin-bottom: 12px">{{ info.bio }}</div>
        <div class="mentor-bio tag-text">行业领域：{{ industryText }}</div>
        <div class="mentor-bio tag-text">服务类型：{{ serviceText }}</div>
        <div v-if="info.bottom_center_label" class="bottom-label">
          <img src="https://logo.wondercv.com/banners/jJhuRkUg5MsKzd5.png" alt="" />
          {{ info.bottom_center_label }}
        </div>
      </div>
    </div>
    <div class="detail-bio-container">
      <div class="detail-bio-title">导师简介</div>
      <div class="detail-bio-content">{{ info.detailed_bio }}</div>
    </div>
    <div v-if="info.top_right_label" class="top-right-label">{{ info.top_right_label }}</div>
  </div>
</template>
<script>
export default {
  name: 'BlockMentor',
  props: {
    info: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {};
  },
  computed: {
    serviceText() {
      return this.info.service_content?.join('、');
    },
    industryText() {
      return this.info.industry?.join('、');
    },
  },
};
</script>
<style lang="scss" scoped>
.block-mentor-container {
  position: relative;
  margin-top: 24px;
  border-radius: 12px;
  background-color: #fff;
  padding: 24px 20px 24px 24px;
  width: 1200px;
  box-sizing: border-box;
  .mentor-info-content {
    .mentor-avatar {
      width: 137px;
      object-fit: cover;
      border-radius: 8px;
      margin-right: 20px;
    }
    .info-content {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 360px;
      color: #4b596b;
      margin-right: 60px;
      .mentor-name {
        margin-bottom: 12px;
        .name {
          color: #1c212a;
          font-size: 18px;
          font-weight: 500;
          margin-right: 8px;
        }
        .rating-icon {
          width: 14px;
          height: 14px;
          margin-right: 6px;
        }
        .rating-text {
          color: #f64;
          font-size: 12px;
          font-weight: 500;
        }
      }
      .mentor-bio {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
      }
      .tag-text {
        line-height: 20px;
      }
      .bottom-label {
        position: absolute;
        display: flex;
        align-items: center;
        padding: 6px 12px 6px 20px;
        border: 1px solid #ff6644;
        border-radius: 0 200px 200px 0;
        font-size: 12px;
        color: #ff6644;
        font-weight: 500;
        background-color: #fff2ef;
        margin-left: 12px;
        height: 24px;
        box-sizing: border-box;
        width: fit-content;
        bottom: 0;
        img {
          position: absolute;
          z-index: 1;
          width: 24px;
          height: 24px;
          left: -12px;
        }
      }
    }
  }
  .detail-bio-container {
    .detail-bio-title {
      color: #1c212a;
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 8px;
    }
    .detail-bio-content {
      color: #4b596b;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 6;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }
  }
  .top-right-label {
    position: absolute;
    padding: 8px 12px;
    top: 0;
    right: 0;
    border-radius: 0px 12px;
    background: linear-gradient(86deg, #ffb264 0%, #ff4f28 100%);
    color: #fff;
    font-size: 12px;
    line-height: 12px;
    font-weight: 600;
  }
}
</style>
